export const certifications = [
  {
    id: 1,
    title: 'Mastering Data Structures & Algorithms using C and C++',
    provider: 'Udemy',
    instructor: 'Abdul Bari',
    completed: 'July 8, 2025',
    skills: ['Data Structures', 'Algorithms', 'C', 'C++'],
    extra: '76 hours total training',
    icon: null,
    file: '/images/certificates/CertificateFor mastering data steucture & algorithms.pdf'
  },
  {
    id: 2,
    title: 'Certificate for the Completion of C++ Training',
    provider: 'Spoken Tutorial Project, IIT Bombay',
    completed: 'December 20, 2024',
    skills: ['C++ Programming'],
    extra: 'Score 95%, Credits: 2 (Online proctored exam)',
    icon: null,
    file: '/images/certificates/CertificateForCompletionOfC++trainingByIITBombay.pdf'
  },
  {
    id: 3,
    title: 'Certificate for the Completion of C Training',
    provider: 'Spoken Tutorial Project, IIT Bombay',
    completed: 'December 20, 2024',
    skills: ['C Programming'],
    extra: 'Score 67.5%, Credits: 2 (Online proctored exam)',
    icon: null,
    file: '/images/certificates/CertificateForCompletionOfCtrainingByIITBombay.pdf'
  },
  {
    id: 4,
    title: 'Machine Learning using Python Programming',
    provider: 'Udemy',
    instructor: 'Sujithkumar MA',
    completed: 'Aug 25, 2025',
    skills: ['Machine Learning', 'Python'],
    extra: '8 hours',
    icon: null,
    file: '/images/certificates/machine learning using python programming.pdf'
  },
  {
    id: 5,
    title: 'n8n Course: No Code AI Agent Builder',
    provider: 'AI-GPTWWorkshop (YouTube)',
    completed: 'Dec 6, 2025',
    skills: ['No-Code AI Agents', 'n8n Integration'],
    extra: 'Certificate Code: 9538920',
    icon: null,
    file: '/images/certificates/n8n course.pdf'
  },
  {
    id: 6,
    title: 'Power BI Mastery: Zero to Hero Data Skills',
    provider: 'Udemy',
    instructor: 'Meta Brains',
    completed: 'March 2, 2025',
    skills: ['Power BI', 'Data Skills'],
    extra: '6.5 hours',
    icon: null,
    file: '/images/certificates/power bi mastery.pdf'
  },
  {
    id: 7,
    title: 'Python for Data Science Pro: The Complete Mastery Course',
    provider: 'Udemy',
    instructor: 'Sara Academy',
    completed: 'Feb 13, 2025',
    skills: ['Python', 'Data Science Basics'],
    extra: '4 hours',
    icon: null,
    file: '/images/certificates/python for data science pro.pdf'
  },
  {
    id: 8,
    title: 'Python Programming Masterclass',
    provider: 'Udemy',
    instructor: 'Makeintern Course',
    completed: 'Feb 17, 2025',
    skills: ['Python Programming'],
    extra: '2.5 hours',
    icon: null,
    file: '/images/certificates/python programming Masterclass.pdf'
  },
  {
    id: 9,
    title: 'SQL (Basic)',
    provider: 'HackerRank',
    completed: 'Nov 6, 2025',
    skills: ['SQL Querying'],
    extra: 'Certification ID: 7IEB45A9FF20',
    icon: null,
    file: '/images/certificates/sql_basic certificate.pdf'
  },
  {
    id: 10,
    title: 'The Complete Java Programmer: From Scratch to Advanced',
    provider: 'Udemy',
    instructor: 'Sujithkumar MA',
    completed: 'Sept 29, 2025',
    skills: ['Java Development'],
    extra: '9 hours',
    icon: null,
    file: '/images/certificates/the complete java programmer.pdf'
  },
  {
    id: 11,
    title: 'Prompt Engineering PRO (AI Prompt Engineering FAST-TRACK)',
    provider: 'Udemy',
    instructor: 'ExpertEase Education',
    completed: 'July 21, 2025',
    skills: ['Prompt Engineering', 'AI Prompt Engineering'],
    extra: '2 hours total',
    icon: null,
    file: '/images/certificates/Prompt Engineering PRO.pdf'
  }
];

export const getCertifications = () => certifications;
